import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import heroImage from "../assets/formLogo2.png";

const RegistrationForm = ({ template }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [fieldWarning, setFieldWarning] = useState({
    mobile: "",
  });
  useEffect(() => {
    localStorage.setItem("template_code", template);
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobile") {
      const numericValue = value.replace(/\D/g, "");

      setFormData((prev) => ({
        ...prev,
        [name]: numericValue,
      }));

      const mobileRegex = /^[6-9]\d{9}$/;

      if (numericValue.length > 0 && !mobileRegex.test(numericValue)) {
        setFieldWarning((prev) => ({
          ...prev,
          mobile: "Please enter a valid 10-digit mobile number",
        }));
      } else {
        setFieldWarning((prev) => ({
          ...prev,
          mobile: "",
        }));
      }

      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.mobile) {
      setFieldWarning(true);
      return;
    }

    setFieldWarning(false);

    const API_URL = `${process.env.REACT_APP_API_URL}/users`;

    const body = {
      name: formData.name,
      mobile: formData.mobile,
      template_code: localStorage.getItem("template_code"),
    };

    const config = {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    };

    try {
      setIsLoading(true);
      const { data } = await axios.post(API_URL, body, config);

      if (data?.success) {
        const userData = {
          id: data.payload.id,
          name: data.payload.name,
          mobile: data.payload.mobile,
        };

        localStorage.setItem("user", JSON.stringify(userData));
        setIsLoading(false);
        navigate(
          `/languages?template_code=${localStorage.getItem("template_code")}`,
        );
      }
    } catch (error) {
      setIsLoading(false);
      console.log("Registration Error:", error);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.leftPanel}>
          <div style={styles.leftInner}>
            <img
              src={heroImage}
              alt="Quiz Illustration"
              style={styles.heroImage}
            />
          </div>
        </div>

        <div style={styles.rightPanel}>
          <div style={styles.formContainer}>
            <div style={styles.headingContainer}>
              <p style={styles.welcomeText}>Welcome to the</p>

              <h1 style={styles.title}>
                <span style={styles.titleBrand}>GoApptiv </span>
                <span style={styles.titleDark}>Quiz</span>
              </h1>

              <p style={styles.subtitle}>
                Enter your details below to begin
                <br />
                the assessment.
              </p>
            </div>

            <form style={styles.form} onSubmit={handleSubmit}>
              <div style={styles.fieldContainer}>
                <label style={styles.label}>Name</label>

                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  style={styles.input}
                />
              </div>

              <div style={styles.fieldContainer}>
                <label style={styles.label}>Mobile Number</label>

                <input
                  type="text"
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="Enter mobile number"
                  maxLength={10}
                  style={styles.input}
                />

                {fieldWarning.mobile && (
                  <p
                    style={{ color: "red", marginTop: "5px", fontSize: "14px" }}
                  >
                    {fieldWarning.mobile}
                  </p>
                )}
              </div>

              {formData.name === "" ||
                (formData.mobile === "" && (
                  <p style={styles.warningText}>Please fill all the fields</p>
                ))}

              <button
                disabled={formData.name === "" || formData.mobile === ""}
                type="submit"
                style={{
                  ...styles.button,
                  ...(formData.name === "" || formData.mobile.length < 10
                    ? styles.disabledBtn
                    : {}),
                }}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Start Quiz "}
                <span style={styles.arrow}>→</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
const isMobile = window.innerWidth <= 768;
const styles = {
  page: {
    minHeight: "100%",
    height: "auto",
    overflow: "hidden",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    // padding: "5px",
    boxSizing: "border-box",
    fontFamily: "'Segoe UI', sans-serif",
    overflowX: "hidden",
  },

  card: {
    width: "100%",
    maxWidth: "1440px",
    height: "100%",
    maxHeight: "100vh",
    backgroundColor: "#ffffff",
    borderRadius: "clamp(18px, 3vw, 32px)",
    overflow: "hidden",

    display: "flex",
    flexWrap: "wrap",
    overflow: "auto",

    boxShadow: "0 20px 60px rgba(0,0,0,0.12)",
  },

  leftPanel: {
    flex: "1 1 500px",
    minWidth: "320px",
    display: "flex",
  },

  leftInner: {
    flex: 1,
    maxHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    padding: "clamp(20px, 4vw, 50px)",
    overflow: "hidden",

    borderTopRightRadius: "clamp(30px, 6vw, 90px)",
    borderBottomRightRadius: "clamp(30px, 6vw, 90px)",

    backgroundImage: `
      linear-gradient(180deg, #f8e6be 0%, #f7a600 100%),
      linear-gradient(45deg, rgba(245,158,11,0.25) 1px, transparent 1px),
      linear-gradient(-45deg, rgba(245,158,11,0.25) 1px, transparent 1px)
    `,

    backgroundSize: "100% 100%, 60px 60px, 60px 60px",
  },

  heroImage: {
    width: "100%",
    maxWidth: "640px",
    height: "auto",
    maxHeight: isMobile ? "40vh" : "90vh",
    objectFit: "contain",
    display: "block",
  },

  rightPanel: {
    flex: "1 1 450px",
    minWidth: "320px",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",

    padding: "clamp(24px, 5vw, 60px)",
    boxSizing: "border-box",
  },

  formContainer: {
    width: "100%",
    maxWidth: "420px",

    display: "flex",
    flexDirection: "column",
  },

  logoWrapper: {
    marginBottom: "clamp(24px, 4vw, 48px)",
  },

  logoImage: {
    width: "clamp(120px, 20vw, 180px)",
    objectFit: "contain",
  },

  headingContainer: {
    marginBottom: "clamp(24px, 4vw, 40px)",
  },

  welcomeText: {
    margin: 0,
    fontSize: "clamp(16px, 2vw, 22px)",
    color: "#111827",
    fontWeight: 400,
  },

  title: {
    margin: "8px 0 18px",
    fontSize: "clamp(32px, 5vw, 48px)",
    lineHeight: 1.1,
    fontWeight: 700,
  },

  titleBrand: {
    color: "#f7a600",
  },

  titleDark: {
    color: "#111827",
  },

  subtitle: {
    margin: 0,
    fontSize: "clamp(14px, 2vw, 16px)",
    lineHeight: 1.7,
    color: "#6b7280",
  },

  form: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },

  fieldContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  label: {
    fontSize: "14px",
    color: "#374151",
    fontWeight: 500,
  },

  input: {
    width: "100%",
    height: "58px",

    borderRadius: "14px",
    border: "1.5px solid #e5e7eb",

    padding: "0 18px",

    fontSize: "15px",

    backgroundColor: "#f9fafb",

    outline: "none",

    transition: "0.2s ease",

    boxSizing: "border-box",
  },

  warningText: {
    margin: 0,
    color: "#ef4444",
    fontSize: "13px",
  },

  button: {
    width: "100%",
    minHeight: "58px",

    border: "none",
    borderRadius: "14px",

    backgroundColor: "#f7a600",
    color: "#ffffff",

    fontSize: "clamp(15px, 2vw, 17px)",
    fontWeight: 600,

    cursor: "pointer",

    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",

    marginTop: "6px",

    transition: "all 0.2s ease",

    padding: "14px 20px",
  },

  arrow: {
    fontSize: "20px",
    lineHeight: 1,
  },
  disabledBtn: {
    backgroundColor: "#BDBDBD",
    cursor: "not-allowed",
    opacity: 0.6,
  },
};

export default RegistrationForm;
